// extracted by mini-css-extract-plugin
export var modal = "_m6-0";